// Копирайт миски и пейволла — spec/08_copy.md, разделы «bowl» и «paywall».
// Голос — вариант A «своя в чате» (docs/copy-variants.md).
// Рода тут нет ни в одной строке: текст экрана «спасибо» переписан основателем и склонять
// в нём нечего, поэтому пар через `textByGender` в этом файле больше не осталось.
//
// Что подписка делает на самом деле (правка основателя — экран обещал не то, что умеет код):
// ограничений в продукте ровно два, оба в `contracts/domain/limits.ts`, и подписка снимает оба.
// Совместимость целиком (включая время и город), натальная карта, прогноз со сбываемостью
// и статистика бесплатны и ни в одной ветке кода на `isPremium` не смотрят. Было обещано
// «до 7 своих» (числа 7 в коде нет вовсе) и «глубокая совместимость» (она бесплатная).
// Поэтому числа теперь подставляются из констант, а не пишутся словами.
import { DAILY_RAY_LIMIT, FREE_LINK_LIMIT } from '@lunya/contracts'

import type { BowlCopy, PaywallCopy } from './types'

// Формулировка «я перестану считать» / «узы без потолка» путала (правка редактора): человек
// читает список выгод, а ему говорят про счётчик Луни. Теперь строки прямо называют, что
// станет можно, и рядом — сколько можно сейчас.
export const bowl: BowlCopy = {
  body: 'Немного денюжек на корм — и ты сможешь:',
  f1: () => `заводить сколько угодно уз — сейчас не больше ${FREE_LINK_LIMIT}`,
  f2: () => `отправлять лучики без ограничений — сейчас ${DAILY_RAY_LIMIT} в сутки`,
  free_note:
    'Совместимость, натальная карта, прогноз и статистика бесплатные — за них платить не надо.',
  love: 'Если что, я и без этого буду тебя любить! 🐾',
  cta: 'Дать денюжек 🍖',
  skip: 'Я и так с тобой',
}

export const paywall: PaywallCopy = {
  title: 'Корм для Луни',
  subtitle:
    'Ограничения в приложении всего два — сколько уз и сколько лучиков в сутки. Подписка снимает оба.',
  cta: 'Оформить',
  thanks_title: 'Спасибо тебе!',
  // Текст основателя дословно. Пола тут нет ни в одной форме, поэтому строка простая,
  // а не пара через `textByGender`: склонять нечего.
  thanks_body: 'Подписку я ещё не продаю, пока не могу( Но я записала тебя в любимчики!',
  thanks_cta: 'Хорошо',
}
